import { OrganeIcon } from "@logora/parliament.icons.regular_icons";
import {
	formatChambre,
	formatLabel,
	formatBooleen,
	formatCell,
} from "../formatters";

const columns = [
	{
		header: "Chambre",
		accessorKey: "chambre",
		cell: (info) => formatChambre(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Chambre",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{
						value: "AN",
						label: "AN",
					},
					{
						value: "SN",
						label: "SN",
					},
				],
			},
		},
	},
	{
		header: "Type",
		accessorKey: "type",
		cell: (info) => formatLabel(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Type",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: "Circonscription", label: "Circonscription" },
					{ value: "Groupe politique", label: "Groupe politique" },
					{ value: "Commission permanente", label: "Commission permanente" },
					{ value: "Commission d'enquête", label: "Commission d'enquête" },
					{ value: "Commission spéciale", label: "Commission spéciale" },
					{ value: "Délégation", label: "Délégation" },
					{ value: "Mission d'information", label: "Mission d'information" },
					{
						value: "Commission mixte paritaire",
						label: "Commission mixte paritaire",
					},
					{ value: "Groupe d'amitié", label: "Groupe d'amitié" },
					{ value: "Groupe d'étude", label: "Groupe d'étude" },
					{ value: "Office parlementaire", label: "Office parlementaire" },
					{ value: "Institution", label: "Institution" },
					{ value: "Ministère", label: "Ministère" },
					{ value: "Gouvernement", label: "Gouvernement" },
					{ value: "Organe politique", label: "Organe politique" },
					{ value: "Organe externe", label: "Organe externe" },
					{
						value: "Autorité administrative indépendante",
						label: "Autorité administrative indépendante",
					},
					{ value: "Assemblée", label: "Assemblée" },
					{ value: "Sénat", label: "Sénat" },
					{ value: "Parti politique", label: "Parti politique" },
				],
			},
		},
	},
	{ header: "Nom", accessorKey: "libelle", enableSorting: false },
	{
		header: "Nombre de membres",
		accessorKey: "nombreMembres",
		defaultSorting: "desc",
	},
	{
		header: "Actif",
		accessorKey: "actif",
		cell: (info) => formatBooleen(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Actif",
				variant: "select",
				defaultValue: true,
				options: [
					{ value: null, label: "Tous" },
					{
						value: true,
						label: "Actif",
					},
					{
						value: false,
						label: "Non actif",
					},
				],
			},
		},
	},
];

export const organeDataset = {
	key: "organes",
	name: "Organes",
	columns: columns,
	filterMapping: { organeRefUid: "uid", acteurRefUid: "acteurPrincipalRefUid" },
	icon: <OrganeIcon width={20} height={20} />,
};
